@if (cmsPage) {
  <div class="category-cms-tile h-100">
    @switch (gridWidth) {
      @case (1) {
        <div class="card h-100 d-flex flex-column">
          <div class="flex-shrink-0 overflow-hidden" style="height: 52%;">
            <wagtail-page-element-image
              [image]="cmsPage.shop_cat.value.header_image.picture_tag_info"
              loading="lazy"
            ></wagtail-page-element-image>
          </div>

          <div class="card-body flex-grow-1 d-flex flex-column">
            <h5 class="card-title" aria-level="2">{{ cmsPage.shop_cat.value.header_title }}</h5>
            <div class="card-text d-none d-sm-block flex-grow-1" [innerHTML]="cmsPage.shop_cat.value.body_text | sanitize"></div>
            <div class="card-footer mt-auto">
              <a href="{{ cmsPage.meta.html_url }}" class="btn btn-sm btn-black" [attr.aria-label]="'Mehr dazu: ' + cmsPage.shop_cat.value.header_title">mehr dazu</a>
            </div>
          </div>
        </div>
      }
      @default {
        <div class="card h-100">
          <div class="row g-0 h-100 d-flex align-items-stretch">
            <div class="{{gridWidth == 2 ? 'col-md-6 h-100 overflow-hidden pe-0' : 'col-md-8 h-100 overflow-hidden pe-0'}}">
              <wagtail-page-element-image
                [image]="cmsPage.shop_cat.value.header_image.picture_tag_info"
                loading="lazy"
              ></wagtail-page-element-image>
            </div>
            <div class="{{gridWidth == 2 ? 'col-md-6' : 'col-md-4'}}">
              <div class="card-body h-100 d-flex flex-column">
                <h5 class="card-title" aria-level="2">{{ cmsPage.shop_cat.value.header_title }}</h5>
                <div class="card-text flex-grow-1" [innerHTML]="cmsPage.shop_cat.value.body_text | sanitize"></div>
                <div class="card-footer mt-auto">
                  <a href="{{ cmsPage.meta.html_url }}" class="btn btn-sm btn-black" [attr.aria-label]="'Mehr dazu: ' + cmsPage.shop_cat.value.header_title">mehr dazu</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    }
  </div>
}
